import { Overlay, Tooltip } from 'react-bootstrap';
import { useRef, useState } from 'react';


const Meaning = ({content,word}) => {
    const [show, setShow] = useState(false);
    const target = useRef(null);
  
    return (
        <>
        <a ref={target} onClick={() => setShow(!show)} style={{"textDecoration":"underline"}}>
            {word}
        </a>
        <Overlay target={target.current} show={show} placement="bottom">
            {(props) => (
            <Tooltip id="overlay-example" {...props}>
                {content}
            </Tooltip>
            )}
        </Overlay>
        </>
    );
}

export default Meaning;